
import Vue from "vue";
export default Vue.extend({
	// Duplicate of v2
	props: {
		label: {
			type: [Object, String]
		},
		// eslint-disable-next-line vue/require-prop-types
		value: {
		},
		decimals: {
			type: Number,
			default: 2
		},
		textarea: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		hasValue():boolean{
			return this.value != null && this.value !== "";
		},
		computedValue():any{
			if (typeof(this.value) == "boolean"){
				if (this.value){
					return "Ja";
				}
				return "Nee";
			}
			if (typeof(this.value) == "number"){
				return this.value.toFixed(this.decimals);
			}
			if (this.value instanceof Date){
				return this.value.toLocaleDateString(("nl-be"));
			}
			return this.value;
		}
	}
});
